var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMozambique(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.52 72.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M27.38 48.43c-1.09-1.93-5.72-9.43-7.58-9.82-2.24-.54-2.4-1.62-2.32-3.79a24.2 24.2 0 0 0-.7-6.18c-.46-2.4.55-3.25 1.71-5.18.38-.62.15-1.7.77-2.09.85-.39 1.78-.08 2.63-.15V21a1.34 1.34 0 0 0-.31-.92 13 13 0 0 0-1.47-1.32c-1.39-1.54-.85-2.63-.54-4.48.15-.93-.39-1.86-.54-2.79-.03-1.1-.03-2.1-.16-3.19-.23-2.32-2.32-4-3.79-5.64-1.54-.93-.62 2-1.85 1.24A5.9 5.9 0 0 0 10 3.43c-.77 0-1.08-.92-2.09-1L5.19 1.5c0 .39.38.54.46.62.15.62.08 1.85.93 1.24s1.16.69 1.31 1.16c.39.92 1.08.69.62 1.93s.23 1.24 1 1.78.46 1.78 1 2.47.85.93.39 1.7c-.38.6-1.07 1.6-1.85 1.6s-1.78.23-1.39 1.39c.39.93 1.08 1.54.54 2.63-.38.69-1.39 1.62-1.08 2.47A4.43 4.43 0 0 1 7.66 23a12.3 12.3 0 0 0-.39 3.33c.08.7.55 1.47 1.4 1.39 1.23-.15-.47 1.55-.85 1.7C7 29.8 5 29.88 4.49 31a4.06 4.06 0 0 0 0 1.93 11.3 11.3 0 0 1-1.62 5c-.39.38-1 .54-1.32 1s.85.47.93.78-.31.46-.23.77.46.23.62.39c.46.38.54 1.08.85 1.62.38.69.69 0 1.16-.23s.77.38.31.69l.54-.15c1.08.93 1.16 2.55 2.09 3.63.07-1.08.77.62.92.93.39.93 4.64-.77 5.88-.85 1.55-.08 1.93 1.86 2 3.09.31 2.32.31 4.18-1 6.11-.46.62-.3 1.47-.77 2.09s-1.39.93-1.39 1.78 1.16 1.23 1.24 2.24 3 5.33 4.79 6.18c1.93 1-1.08 2.25.7 3s1.77-2.86 1.23-3.79c-.62-1.16-.92-1.16 0-2.32.54-.62.31-1.55.85-2.16 1.16-1.4 3.48.23 4.33-1.78s.62-4.33.62-6.26a4.14 4.14 0 0 1 .78-2.86 5.7 5.7 0 0 0-.62-3.4",
    "data-name": "Layer 93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMozambique);
export default __webpack_public_path__ + "static/media/mozambique.989b9861aee8ab7d2763acaba198eb4d.svg";
export { ForwardRef as ReactComponent };